import type { VoidFunctionComponent } from 'react';

import colors from '../../../theme/colors';

/**
 * ListRowDetailsSeparator
 */
const ListRowDetailsSeparator: VoidFunctionComponent = () => (
  <svg
    className="fossa-list__row__details__item fossa-list__row__details__item--separator"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    width="4px"
    height="4px"
    aria-hidden="true"
  >
    <circle cx="5" cy="5" r="5" fill={colors.fossaGray40} />
  </svg>
);

export default ListRowDetailsSeparator;
